import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, Package, FileText, Image, HelpCircle, MessageSquare, Inbox, Settings, LogOut, FolderOpen, Layers, Activity, Database } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import AdminLogo from "@/components/admin/AdminLogo";

const nav = [
  { to: "/admin", icon: LayoutDashboard, label: "Dashboard", end: true },
  { to: "/admin/pages", icon: Layers, label: "Pages" },
  { to: "/admin/products", icon: Package, label: "Produk" },
  { to: "/admin/articles", icon: FileText, label: "Artikel" },
  { to: "/admin/gallery", icon: Image, label: "Galeri" },
  { to: "/admin/faq", icon: HelpCircle, label: "FAQ" },
  { to: "/admin/testimonials", icon: MessageSquare, label: "Testimoni" },
  { to: "/admin/leads", icon: Inbox, label: "Leads / Kontak" },
  { to: "/admin/media", icon: FolderOpen, label: "Media" },
  { to: "/admin/activity", icon: Activity, label: "Activity Log" },
  { to: "/admin/backup", icon: Database, label: "Backup" },
  { to: "/admin/settings", icon: Settings, label: "Pengaturan" },
];

const AdminLayout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-zinc-50 flex">
      <aside className="w-64 bg-zinc-950 text-zinc-300 flex flex-col fixed inset-y-0 left-0 z-30" data-testid="admin-sidebar">
        <div className="p-5 border-b border-zinc-800">
          <AdminLogo className="h-12" padded />
          <div className="mt-3 font-display font-bold text-white">Mandala CMS</div>
          <div className="text-[10px] uppercase tracking-widest text-zinc-500">Admin Panel</div>
        </div>
        <nav className="flex-1 p-3 space-y-1 overflow-y-auto">
          {nav.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              data-testid={`sidebar-${n.label.toLowerCase().replace(/\s|\//g, "-")}`}
              className={({ isActive }) => `flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm font-medium transition ${isActive ? "bg-maroon-700 text-white" : "text-zinc-400 hover:bg-zinc-900 hover:text-white"}`}
            >
              <n.icon size={16} />
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-zinc-800">
          <div className="text-xs text-zinc-500 truncate">{user?.email}</div>
          <button
            onClick={async () => { await logout(); navigate("/admin/login"); }}
            data-testid="admin-logout"
            className="mt-2 w-full inline-flex items-center gap-2 px-4 py-2 rounded-lg text-sm text-zinc-300 hover:bg-red-500 hover:text-white transition"
          >
            <LogOut size={14} /> Logout
          </button>
        </div>
      </aside>
      <main className="flex-1 ml-64 p-8">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
